// baseurl.js
export const baseURL = 'https://cdn-sport.benatky.app';
